// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1Hxxm","content":"LoadingAlert_content__1AfoF"};